(function($) {

	if($('.home-header-mobile2').length && $('.home-header-mobile2').is(":visible")){
	
		var header_height = $('#masthead').offset().top;
		if($(document).width()<1200) header_height = $('#mobile-masthead').offset().top;

		$(window).scroll(function(){
			//if($(window).width() > 1200 ) {

				if($(window).scrollTop() > header_height) {
					$('.site-header').addClass('fixed');
					$('.home-header-mobile2').addClass('fixed');
				} else {
					$('.site-header').removeClass('fixed');
					$('.home-header-mobile2').removeClass('fixed');
				}
			//}
			
		});
	}

})(jQuery);